"use client";

import { useEffect } from "react";
import { Button } from "@shared/src/components/ui/button";

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    console.error("Error:", error);
  }, [error]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-8">
      <h1 className="text-2xl font-bold">Something went wrong!</h1>
      <p className="text-text-secondary">{error.message}</p>
      <Button onClick={reset} variant="primary" size="lg" radius="full" width="default" className="px-6 py-4 h-auto">
        Try again
      </Button>
    </div>
  );
}
